var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmoji(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M10.9994 25C16.8843 25 21.655 23.8465 21.655 22.4236C21.655 21.0007 16.8843 19.8472 10.9994 19.8472C5.11443 19.8472 0.34375 21.0007 0.34375 22.4236C0.34375 23.8465 5.11443 25 10.9994 25Z",
    fill: "#8084C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3402 21.5131C20.9228 19.0708 23.506 12.4782 21.1098 6.78805C18.7136 1.09794 12.2455 -1.53492 6.66291 0.907396C1.08029 3.34971 -1.50283 9.94233 0.893342 15.6324C3.28951 21.3225 9.7576 23.9554 15.3402 21.5131Z",
    fill: "#FFE663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7796 12.3678C20.7796 13.0056 19.9985 13.5149 19.0351 13.5149C18.0718 13.5149 17.293 12.9964 17.293 12.3678C17.293 11.7392 18.0718 11.2207 19.0351 11.2207C19.9985 11.2207 20.7796 11.73 20.7796 12.3678Z",
    fill: "#EDB9D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6445 12.3678C4.6445 13.0056 3.8657 13.5149 2.90233 13.5149C1.93896 13.5149 1.16016 12.9964 1.16016 12.3678C1.16016 11.7392 1.93896 11.2207 2.90233 11.2207C3.8657 11.2207 4.6445 11.73 4.6445 12.3678Z",
    fill: "#EDB9D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8952 16.4151C14.9319 17.729 13.4987 18.6023 11.9071 18.845C10.3156 19.0877 8.69436 18.6803 7.39593 17.7113C6.90648 17.3462 6.47263 16.9094 6.10843 16.4151C5.73253 15.9058 6.08142 15.0867 6.70041 15.1808C8.92877 15.5157 13.0794 15.4721 15.3032 15.1808C15.9222 15.0982 16.2666 15.9058 15.8952 16.4151Z",
    fill: "#666055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.64042 11.7766C5.55287 11.7766 6.29256 11.0227 6.29256 10.0926C6.29256 9.16262 5.55287 8.40869 4.64042 8.40869C3.72797 8.40869 2.98828 9.16262 2.98828 10.0926C2.98828 11.0227 3.72797 11.7766 4.64042 11.7766Z",
    fill: "#666055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4606 10.9322H15.8203L17.5062 9.21387",
    stroke: "#666055",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.375 2.88184L16.5753 3.02178",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7617 1.40869C13.7477 1.59117 14.6999 1.92862 15.5843 2.40897",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji);
export default __webpack_public_path__ + "static/media/emoji.c552b1a9.svg";
export { ForwardRef as ReactComponent };